if (location.pathname.includes("/account") && !location.pathname.includes("/addresses") && location.search == "") {
  document.querySelector(".account-main")?.classList.add("active");
}

if (location.pathname.includes("/account") && location.search.includes("view=orders")) {
  document.querySelector(".account-orders")?.classList.add("active");
}

if (location.pathname.includes("/account") && location.search.includes("view=wishlist")) {
  document.querySelector(".account-wishlist")?.classList.add("active");
}

if (location.pathname.includes("/account") && location.search.includes("view=bonuses")) {
  document.querySelector(".account-bonuses")?.classList.add("active");
}

let shippingAddressInput = document.querySelector('[name="shipping_address"]');
shippingAddressInput?.addEventListener("change", function (e) {
  console.log(e);

  document.querySelectorAll(".input__shipping-address")?.forEach((el) => {
    el.classList.toggle("hidden");
  });
});

let regularCustomer = document.querySelector("#customer_regular");
let registerTypeInputs = document.querySelectorAll(".register-types input");
let accordionOriginalTextContent = document.querySelector(".accordion__select-customer-type .accordion__label")?.textContent;

registerTypeInputs?.forEach((input) => {
  input?.addEventListener("change", async function (e) {
    if (input.id == "customer_regular" && input.checked) {
      document.querySelector(".input__date-of-birth")?.classList.remove("hidden");
      document.querySelectorAll(".company-input-field").forEach((el) => {
        el.classList.add("hidden");
      });
      document.querySelector(".marketing-input-field").classList.remove("hidden");
    } else {
      document.querySelector(".input__date-of-birth")?.classList.add("hidden");
      document.querySelectorAll(".company-input-field").forEach((el) => {
        el.classList.remove("hidden");
      });
      document.querySelector(".marketing-input-field").classList.add("hidden");
    }
    let label = document.querySelector(`label[for="${input.id}"]`).textContent;
    let accordionLabel = document.querySelector(".accordion__select-customer-type .accordion__label");
    if (accordionLabel) accordionLabel.textContent = accordionOriginalTextContent + ": " + label;
  });
});

if (window.location.search.includes("registration=success")) {
  const regDob = sessionStorage.getItem("reg_dob");
  const regCompany = sessionStorage.getItem("reg_company");
  const regCompanyId = sessionStorage.getItem("reg_company_id");
  const regVatNumber = sessionStorage.getItem("reg_vat_number");
  const regPhone = sessionStorage.getItem("reg_phone");
  const regTags = sessionStorage.getItem("reg_tags");
  const regObject = {
    reg_dob: regDob,
    reg_company: regCompany,
    reg_company_id: regCompanyId,
    reg_vat_number: regVatNumber,
    reg_phone: regPhone,
    customer_id: window.shopifyCustomer?.id,
    reg_tags: regTags,
  };

  for (const key in regObject) {
    if (regObject[key] === null) {
      delete regObject[key];
    }
  }

  console.log(regObject);

  (async () => {
    await fetch("https://hook.eu2.make.com/9yrhslfw18uh2vg455wdbqhddi2qtmdz", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(regObject),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  })();
}

document.querySelectorAll(".header-sidebar__linklist-button").forEach((el) => {
  el.addEventListener("click", function (e) {
    let hasUrl = e.target.hasAttribute("data-follow-link");
    if (hasUrl) {
      window.location.href = e.target.href;
    }
  });
});

const registrationUserTypes = document.querySelectorAll(".radio-wrapper input");

registrationUserTypes.forEach((el) => {
  el.addEventListener("change", function (e) {
    if (el.dataset.type == "b2b") {
      console.log("b2b");
      document.querySelector("input[name='customer[company_id]']").setAttribute("required", "required");
    } else {
      document.querySelector("input[name='customer[company_id]']").removeAttribute("required");
    }
  });
});

function formatMarketMoneyFromCents(cents) {
  const cfg = window.themeVariables?.marketMoney;
  if (!cfg?.rate || !cfg?.iso) {
    return new Intl.NumberFormat(window.Shopify?.locale || undefined, {
      style: "currency",
      currency: window.Shopify?.currency?.active || "CZK",
    }).format(cents / 100);
  }

  const converted = (Math.round(Math.round(cents / cfg.rate) / 10) * 10) / 100;
  return new Intl.NumberFormat(cfg.locale || window.Shopify?.locale || undefined, {
    style: "currency",
    currency: cfg.iso,
  }).format(converted);
}

function patchFreeShippingBar() {
  const Ctor = customElements.get("free-shipping-bar");
  if (!Ctor || Ctor.__tarsioMarketMoneyPatched) return;
  Ctor.__tarsioMarketMoneyPatched = true;

  const proto = Ctor.prototype;
  const original = proto.attributeChangedCallback;
  proto.attributeChangedCallback = function patchedFreeShippingBar(name, oldValue, newValue) {
    if (typeof original === "function") original.call(this, name, oldValue, newValue);
    if (!window.themeVariables?.marketMoney?.rate) return;

    const messageElement = this.querySelector("span");
    if (!messageElement) return;

    const totalPrice = parseFloat(this.getAttribute("total-price")) || 0;
    const threshold = parseFloat(this.getAttribute("threshold")) || 0;
    if (totalPrice >= threshold) {
      messageElement.innerHTML = this.getAttribute("reached-message") || "";
      return;
    }

    const formatted = formatMarketMoneyFromCents(threshold - totalPrice).replace(/\$/g, "$$$$");
    const template = this.getAttribute("unreached-message") || "";
    messageElement.innerHTML = template.replace(/\{\{.*\}\}/g, formatted);
  };

  document.querySelectorAll("free-shipping-bar").forEach((el) => {
    proto.attributeChangedCallback.call(el);
  });
}

if (customElements.get("free-shipping-bar")) {
  patchFreeShippingBar();
} else if (customElements.whenDefined) {
  customElements.whenDefined("free-shipping-bar").then(patchFreeShippingBar);
}
